module.exports = __webpack_public_path__ + "static/media/fb-fail.ab947004.svg";